module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/powered_by_evvnt-5702f1b1d1e61194ee250fb3b226544c.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/powered_by_evvnt.png
// module id = 1588
// module chunks = 0